import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './meta'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faTimes, faMinus } from '@fortawesome/free-solid-svg-icons'
import {
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faTimesCircle,
  faFilter,
  faAngleDown,
  faPlus,
  faCircleNotch,
  faArrowCircleLeft,
  faArrowCircleRight,
  faMap,
  faBullhorn,
  faChartBar,
  faCode,
  faPencilPaintbrush,
  faVideo,
  faPenAlt,
  faMobile
} from '@fortawesome/pro-regular-svg-icons'
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons'
import {
  faFacebookF,
  faInstagram,
  faBehance,
  faVimeo,
  faVimeoV,
  faLinkedin,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'
import { Notification } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/* import 'video.js/src/css/vjs-cdn.scss' */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { VueHammer } from 'vue2-hammer'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
Vue.use(VueHammer)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/img/jpg/Error.jpg',
  loading: '/img/png/Cargando.png',
  attempt: 1
})

// Vue.use(videojs)
library.add(
  faBars,
  faTimes,
  faFacebookF,
  faInstagram,
  faBehance,
  faVimeoV,
  faPlayCircle,
  faPlus,
  faMinus,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faTimesCircle,
  faFilter,
  faCircleNotch,
  faArrowCircleLeft,
  faArrowCircleRight,
  faMap,
  faBullhorn,
  faChartBar,
  faCode,
  faPencilPaintbrush,
  faVideo,
  faPenAlt,
  faCircleNotch,
  faVimeo,
  faMobile,
  faLinkedin,
  faYoutube
)
Vue.prototype.$notify = Notification

Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
